<template>
  <div id="rbv1TabBarItem" @click="itemClick" :class="{selectActive: selectActive}" >
    <div v-show="(type === 'mine' && $store.state.commonParameters.serviceOn === 'true')?$store.state.unreadMessages !== 0:false" id="redPoint"></div>
    <div><slot></slot></div>
  </div>
</template>

<script>
 export default {
  props:{
    path:{type:String},
    type:{type:String},
    showRedPoint:{type:Boolean}
  },
   data () {
     return {

     }
   },
   components: {

   },
   methods:{
    itemClick:function(){
      // console.log(this.type);
      if("close" === this.type){
        this.$emit("close")
        return
      }
      if(this.path == this.$route.path){
        return
      }
      // console.log("replace", this.path);
      // console.log(this.$router)
      this.$router.replace(this.path) 
    }
   },
   computed:{
    selectActive(){
      return this.path == this.$route.path
    }
   },
  //  beforeRouteLeave(to,from,next){

  //   next()
  //  }
 }
</script>

<style>

#rbv1TabBarItem{
  padding-top: 15px;
    text-align: center;
    height: 49px;
    position: relative;
  }
  #rbv1TabBarItem img{
    height: 35px;
    /* width: fit-content; */
    width: 20px;
    vertical-align: middle;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
  }
  .selectActive{
    background-color: #FF9631;
  }
  #redPoint{
    width: 15px;
    height: 15px;
    position: absolute;
    float: right;
    margin-left: 5px;
    /* margin-right: 10px; */
    /* margin-top: 10px; */
    background-color: red;
    border-radius: 10px 10px 10px 10px;
  }
 
</style>


// WEBPACK FOOTER //
// src/views/tabbar/TabBarItem.vue